module.exports = __webpack_public_path__ + "img/23.a0643631.jpg";